import { createSelector } from 'reselect'

import API from '../../api/api'

const MANAGERS_LOAD = 'MANAGERS_LOAD'
const MANAGER_CREATE = 'MANAGER_CREATE'
const MANAGER_UPDATE = 'MANAGER_UPDATE'
const MANAGER_DELETE = 'MANAGER_DELETE'

const initialState = {
  managers: [],
}

const shiftManagersReducer = (state = initialState, action) => {
  switch (action.type) {
    case MANAGERS_LOAD:
      return {
        ...state,
        managers: action.managers,
      }
    case MANAGER_CREATE: {
      return {
        ...state,
        managers: [action.data, ...state.managers],
      }
    }
    case MANAGER_UPDATE: {
      return {
        ...state,
        managers: state.managers.map((manager) => {
          if (manager.id === action.data.id) {
            return action.data
          } else {
            return manager
          }
        }),
      }
    }
    case MANAGER_DELETE: {
      return {
        ...state,
        managers: state.managers.filter((manager) => manager.id !== action.id),
      }
    }
    default:
      return state
  }
}

export const fetchShiftManagers = (buildingId) => {
  return (dispatch) =>
    API.getAllShiftManagers(buildingId)
      .then((res) => {
        dispatch(loadManagers(res))
        return Promise.resolve(res)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

export const createShiftManager = (data) => {
  return (dispatch) =>
    API.createNewManagementUser(data, 'shiftManager')
      .then((res) => {
        if (!res.errCode) dispatch({ type: MANAGER_CREATE, data: res })
        return Promise.resolve(res)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

export const updateShiftManager = (data, id) => {
  return (dispatch) =>
    API.updateManagementUserData(data, id, 'shiftManager')
      .then((res) => {
        if (!res.errCode) dispatch({ type: MANAGER_UPDATE, data: res })
        return Promise.resolve(res)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

export const deleteShiftManager = (id) => {
  return async (dispatch) => {
    try {
      await API.deleteManagementUserData(id, 'shiftManager')
      dispatch({ type: MANAGER_DELETE, id })
    } catch ({ message }) {
      throw new Error(message)
    }
  }
}

export const loadManagers = (managers) => {
  return {
    type: MANAGERS_LOAD,
    managers,
  }
}

export const selectShiftManagers = (state) => state.shiftManagers.managers

export const selectShiftManagerById = createSelector(
  selectShiftManagers,
  (managers) => (shiftManagerId) => {
    if (shiftManagerId === 'new') {
      return {
        user: {},
      }
    }
    return managers.find((manager) => manager.id === parseInt(shiftManagerId)) || { user: {} }
  },
)

export default shiftManagersReducer
